import { Injectable } from '@angular/core';
import { User, UserInterest } from '@ark7/core-business-models';
import {
  A7ResourceAction,
  A7ResourceParams,
  IResourceMethodPromise,
  ResourceHandler,
  ResourceRequestMethod,
} from '@ark7/resource2';
import { BasicUserResource, USER_RECOVER } from '@ark7/resources-common';

const referrer = typeof document !== 'undefined' ? document.referrer : '';
const uri = typeof location !== 'undefined' ? location.href : '';

/**
 * Aurora-specific user resource that deserializes the current user as the
 * full `User` model (instead of the default `Identity`), exposing fields like
 * `isVerifiedAccreditedInvestor`.
 */
@Injectable({ providedIn: 'root' })
@A7ResourceParams({
  withCredentials: true,
  model: User,
  recover: USER_RECOVER,
  pathPrefix: '/api/v2/user',
  headers: {
    'Origin-Referrer': referrer,
    'Origin-Uri': uri,
  },
  signalTopic: 'user',
})
export class UserResource extends BasicUserResource<User> {
  constructor(handler: ResourceHandler) {
    super(handler);
  }

  @A7ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/express-interests',
  })
  _expressInterests: IResourceMethodPromise<
    { interests: UserInterest | UserInterest[] },
    User
  >;
}
